import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { getGateMasterDetailsUrl, getGateMasterListUrl, deleteGateMasterUrl, insertGateMasterUrl, GET_GATE_MASTER_DETAILS, GET_GATE_MASTER_LIST, INSERT_UPDATE_GATE_MASTER, DELETE_GATE_MASTER, headers } from "../../../utils/constants";

export const getGateMasterList_action = (GateName) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
            GateName: GateName !='' ?GateName:null 
        }

        const res = await axiosGet(getGateMasterListUrl, params, headers)

        dispatch({
            type: GET_GATE_MASTER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteGateMaster_action = (GateId) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
            GateID: GateId
        }

        const res = await axiosGet(deleteGateMasterUrl, params, headers)

        dispatch({
            type: DELETE_GATE_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateGateMaster_action = (GateName, GateId) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
            GateName: GateName,
            GateID: GateId,
        }

        const res = await axiosPost(insertGateMasterUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_GATE_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getGateMasterDetails_action = (ExhibitionID, GateId) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
            GateID: GateId
        }

        const res = await axiosGet(getGateMasterDetailsUrl, params, headers)

        dispatch({
            type: GET_GATE_MASTER_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}